import {Dialog, DialogContent, DialogTitle, Grid, Typography} from "@mui/material";
import Cookies from "js-cookie";
import {routes, useGroupUpdateData, usePatchData} from "../routes/api";
import React, {Fragment, useEffect, useState} from "react";
import {isDict} from "../util/util";
import {captureSettingsFields} from "../util/modelFields";
import ErrorDisplay from "./errorDisplay";
import InputField from "./inputField";
import Button from "@mui/material/Button";
import {CaptureSettingsDefaultFields, CaptureSettingsPicFields, CaptureSettingsVidFields} from "../util/getFields";


export default function CaptureSettings({open, setOpen, batch, ids, data = {}, cameraId, refresh}) {
    const token = Cookies.get('token');
    const cameraRoute = routes.camera;
    const cameraGroupRoute = routes.cameragroup;

    const [editedData, setEditedData] = useState(data ? data : {});
    const [fieldChecks, setFieldChecks] = useState(Object.entries(data).reduce((acc, [key, value], _) => ((value === undefined || value === '') ? [...acc, key] : acc), []));
    const [errorFields, setErrorFields] = useState([]);
    // const [error, setError] = useState(false);
    const [alert, setAlert] = useState(false);
    const [batchAlert, setBatchAlert] = useState(false);
    const [touched, setTouched] = useState({});

    const {
        data: groupUpdateResp,
        statusCode: groupUpdateStatus,
        handleCall: groupUpdate
    } = useGroupUpdateData(token, cameraGroupRoute);

    const {
        data: patchResp,
        statusCode: patchStatus,
        handleCall: patchUpdate
    } = usePatchData(token, cameraRoute, cameraId);

    const onBlur = (e) => {
        setTouched({...touched, [e.target.name]: true});
    }

    const handleChange = (e) => {
        if (e.target.value) {
            setEditedData({
                ...editedData,
                [e.target.name]: e.target.value
            });
            setFieldChecks((checks) => (checks.filter(item => item !== e.target.name)));
        } else {
            setEditedData({
                ...editedData,
                [e.target.name]: ''
            });
            setFieldChecks((checks) => ([...checks, e.target.name]));
        }
        setErrorFields((error) => error.filter(item => item !== e.target.name));
    }

    const handleEnumChange = (e) => {
        setEditedData({
            ...editedData,
            [e.target.name]: e.target.value
        });
        setErrorFields((error) => error.filter(item => item !== e.target.name));
    }

    const handleBoolChange = (e) => {
        setEditedData({
            ...editedData,
            [e.target.name]: e.target.checked
        });
    }

    const handleSubmit = () => {
        if (batch) {
            groupUpdate({body: {capture: editedData, cameras: ids}});
        } else {
            patchUpdate({body: {c_capturing: editedData}});
        }
    };
    useEffect(() => {
        if (patchStatus >= 200 && patchStatus < 300) {
            setAlert(false);
            setOpen(false);
            if (refresh) {
                refresh();
            }
        } else if (patchStatus > 300) {
            setAlert(true);
            const errors = isDict(patchResp) ? Object.keys(patchResp) : [];
            setErrorFields(errors);
        }
    }, [patchStatus, patchResp]);

    useEffect(() => {
        if (groupUpdateStatus === 207) {
            setBatchAlert(true);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        } else if (groupUpdateStatus >= 200 && groupUpdateStatus < 300) {
            setBatchAlert(false);
            setOpen(false);
            if (refresh) {
                refresh();
            }
        } else if (groupUpdateStatus > 300) {
            setBatchAlert(true);
            const errors = isDict(groupUpdateResp) ? Object.keys(groupUpdateResp) : [];
            setErrorFields(errors);
        }
    }, [groupUpdateStatus, groupUpdateResp]);

    // useEffect(() => {
    //     if (fieldChecks.length === 0 && errorFields.length === 0) {
    //         setError(false);
    //     }
    // }, [fieldChecks]);


    return <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="popup-dialog-title"
        aria-describedby="popup-dialog-description"
        fullWidth
        scroll='body'
        maxWidth='lg'
    >
        <DialogTitle variant='h5'>
            Update Video/Image Capture Settings
        </DialogTitle>
        <DialogContent
            sx={{
                minWidth: '270px',
                minHeight: '50px',
                overflow: 'visible',
                ml: 3
            }}>
            <Grid container
                  spacing={1}
                  sx={{margin: 'auto', mb: 2}}
                  alignItems="flex-start"
                  justifyContent="center">
                <Grid size={12} key='error-display'>
                    <ErrorDisplay
                        alert={alert}
                        setAlert={setAlert}
                        response={patchResp}
                        fields={captureSettingsFields}
                        statusCode={patchStatus}
                    />
                    <ErrorDisplay
                        alert={batchAlert}
                        setAlert={setBatchAlert}
                        response={groupUpdateResp}
                        fields={captureSettingsFields}
                        statusCode={groupUpdateStatus}
                        batch
                    />
                </Grid>
                {CaptureSettingsDefaultFields.map((field) => (
                    <Grid size={{xs: 12, md: 6, xl: 3}} key={captureSettingsFields.fields[field].alias}
                          sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'stretch'}}>
                        <InputField
                            field={captureSettingsFields.fields[field]}
                            error={errorFields.includes(captureSettingsFields.fields[field].alias)}
                            onChange={handleChange}
                            onEnumChange={handleEnumChange}
                            onBoolChange={handleBoolChange}
                            onBlur={onBlur}
                            value={editedData[captureSettingsFields.fields[field].alias] || false}
                        />
                    </Grid>
                ))}
                <Grid size={12}></Grid>
                <Grid size={{xs: 12, md: 6}} sx={{mt: 3}}>
                    {editedData.cs_picEnable &&
                        <Fragment key='image-capture-settings'>
                            <Grid size={12} sx={{mb: 1}}>
                                <Typography variant='h6'>
                                    Image Capture Settings
                                </Typography>
                            </Grid>
                            {CaptureSettingsPicFields.map((field) => (
                                <Grid size={12} key={captureSettingsFields.fields[field].alias}
                                      sx={{display: 'flex', justifyContent: 'stretch', alignItems: 'stretch'}}>
                                    <InputField
                                        field={captureSettingsFields.fields[field]}
                                        error={errorFields.includes(captureSettingsFields.fields[field].alias) || (editedData.cs_picEnable && (editedData[captureSettingsFields.fields[field].alias] === undefined || editedData[captureSettingsFields.fields[field].alias] === ''))}
                                        onChange={handleChange}
                                        onEnumChange={handleEnumChange}
                                        onBoolChange={handleBoolChange}
                                        onBlur={onBlur}
                                        value={editedData[captureSettingsFields.fields[field].alias] !== undefined ? editedData[captureSettingsFields.fields[field].alias] : ''}
                                    />
                                </Grid>
                            ))}
                        </Fragment>}
                </Grid>
                <Grid size={{xs: 12, md: 6}} sx={{mt: 3}}>
                    {editedData.cs_vidEnable && <>
                        <Grid size={12} sx={{mb: 1}}>
                            <Typography variant='h6'>
                                Video Capture Settings
                            </Typography>
                        </Grid>
                        {CaptureSettingsVidFields.map((field) => (
                            <Grid size={12} key={captureSettingsFields.fields[field].alias}
                                  sx={{display: 'flex', justifyContent: 'stretch', alignItems: 'stretch'}}>
                                <InputField
                                    field={captureSettingsFields.fields[field]}
                                    error={errorFields.includes(captureSettingsFields.fields[field].alias)}
                                    onChange={handleChange}
                                    onEnumChange={handleEnumChange}
                                    onBoolChange={handleBoolChange}
                                    onBlur={onBlur}
                                    value={editedData[captureSettingsFields.fields[field].alias] !== undefined ? editedData[captureSettingsFields.fields[field].alias] : ''}
                                />
                            </Grid>
                        ))}
                    </>}
                </Grid>
                <Grid size={12} key='submit'>
                    <Button component="label"
                            variant="contained"
                            onClick={handleSubmit}
                        // disabled={error}
                            sx={{margin: 2}}>
                        Save
                    </Button>
                </Grid>
            </Grid>
        </DialogContent>
    </Dialog>;
}